<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/fornecedor', query: $route.query }">
        Cadastro/Fornecedores
      </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="12">
            <v-text-field
              label="Fornecedor *"
              v-model="nome"
              v-uppercase
              :counter="200"
              maxlength="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Fornecedor é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="8">
            <v-text-field
              label="Nome Fantasia *"
              v-model="nomeFantasia"
              v-uppercase
              :counter="200"
              maxlength="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Nome Fantasia é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="Produto" value="N/A" readonly></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="4">
            <v-text-field
              label="CNPJ/CPF *"
              v-model="cpf_cnpj"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              :counter="18"
              maxlength="18"
              :readonly="readOnly"
              :rules="[
                (v) => !!v || 'O CPF/CNPJ é obrigatório',
                (v) =>
                  (v && this.validaCpfCnpj(v)) || 'O CPF/CNPJ deve ser válido',
              ]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="IE *"
              v-model="inscricaoEstadual"
              :counter="100"
              maxlength="100"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Inscrição Estadual é obrigatória']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Contato *"
              v-model="contato"
              v-uppercase
              :counter="100"
              maxlength="100"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Contato é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="3">
            <v-text-field
              label="Celular *"
              v-model="celular"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :counter="15"
              maxlength="15"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Celular é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Telefone"
              v-model="telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :readonly="readOnly"
              :counter="15"
              maxlength="15"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Ramal"
              v-model="ramal"
              :counter="15"
              maxlength="15"
              :readonly="readOnly"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="9">
            <emails-field
              ref="emailsField"
              v-model="emailsEdit"
              :readonly="readOnly"
            />
          </v-col>
        </v-row>
        <endereco ref="endereco" :isAllowed="readOnly" :uppercase="true" />
      </v-form>
      <v-row align="center">
        <v-col cols="12" sm="2">
          <v-checkbox
            :readonly="readOnly"
            v-model="fornecedor.ativo"
            label="Ativo"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <slot name="actions">
            <v-btn
              @click="cancelar"
              color="error"
              class="mr-4"
              v-if="!readOnly"
            >
              Voltar
            </v-btn>
            <v-btn @click="cancelar" color="error" class="mr-4" v-else>
              Voltar
            </v-btn>
            <v-btn
              @click="enviar"
              color="success"
              class="mr-4"
              v-if="!readOnly"
            >
              Salvar
            </v-btn>
          </slot>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarFornecedorAsync } from "../../../services/fornecedorService";
import { mapState, mapActions } from "vuex";
import Endereco from "../Endereco";
import { getUserPermission } from "@/services/loginService";
import EmailsField from "./EmailsField";

export default {
  name: "editarFornecedor",
  data: () => ({
    overlay: false,
    nome: null,
    nomeFantasia: null,
    cpf_cnpj: null,
    inscricaoEstadual: null,
    contato: null,
    celular: null,
    telefone: null,
    ramal: null,
    readOnly: false,
    emailsEdit: [],
  }),
  computed: {
    ...mapState("fornecedor", ["fornecedor"]),
  },
  methods: {
    ...mapActions("fornecedor", ["updateFornecedor"]),
    async enviar() {
      const emailsValidos = this.$refs.emailsField.commitPendingEmail();
      var enderecoValido = this.$refs.endereco.updateObjectEstate();
      if (emailsValidos && this.$refs.form.validate() && enderecoValido) {
        const existentes = this.fornecedor.emails || [];

        const payloadEmails = this.emailsEdit.map((email) => {
          const achou = existentes.find(
            (x) =>
              x.email?.trim().toLocaleLowerCase() ===
              email.toLocaleLowerCase()
          );
          return achou
            ? { ...achou, email, ativo: true }
            : {
                id: null,
                idFornecedor: this.fornecedor.id,
                email,
                ativo: true,
              };
        });

        // opcional: marcar removidos como inativos
        const removidos = existentes
          .filter(
            (x) =>
              !this.emailsEdit.some(
                (email) =>
                  email.toLocaleLowerCase() ===
                  x.email?.trim().toLocaleLowerCase()
              )
          )
          .map((x) => ({ ...x, ativo: false }));
        this.overlay = true;
        try {
          const resposta = await editarFornecedorAsync(
            this.fornecedor.id,
            this.nome,
            this.nomeFantasia,
            this.cpf_cnpj,
            this.inscricaoEstadual,
            this.contato,
            this.celular,
            this.telefone,
            this.ramal,
            [...payloadEmails, ...removidos],
            this.$refs.endereco.cep,
            this.$refs.endereco.logradouro,
            this.$refs.endereco.numero,
            this.$refs.endereco.complemento,
            this.$refs.endereco.bairro,
            this.$refs.endereco.cidade,
            this.$refs.endereco.uf,
            this.fornecedor.ativo
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message,
              "Descupe, falha na operação!",
              "error"
            );
          } else {
            this.updateFornecedor(resposta.data || this.mountObjFornecedor());
            this.$store.dispatch("ui/showSnackbar", {
              text: "Salvo com sucesso!",
              color: "success",
              timeout: 3000,
            });
            if (this.onCancelar) {
              this.onCancelar();
            } else {
              this.$router.push({
                path: "/fornecedor",
                query: this.$route.query,
              });
            }
          }
        } finally {
          this.overlay = false;
        }
      }
    },
    cancelar() {
      if (this.onCancelar) {
        this.onCancelar();
      } else {
        this.$router.push({ path: "/fornecedor", query: this.$route.query });
      }
    },
    validaCpfCnpj(val) {
      if (val.length == 14) {
        let cpf = val.trim();

        cpf = cpf.replace(/\./g, "");
        cpf = cpf.replace("-", "");
        cpf = cpf.split("");

        let v1 = 0;
        let v2 = 0;
        let aux = false;

        for (let i = 1; cpf.length > i; i++) {
          if (cpf[i - 1] != cpf[i]) {
            aux = true;
          }
        }

        if (aux == false) {
          return false;
        }

        for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
          v1 += cpf[i] * p;
        }

        v1 = (v1 * 10) % 11;

        if (v1 == 10) {
          v1 = 0;
        }

        if (v1 != cpf[9]) {
          return false;
        }

        for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
          v2 += cpf[i] * p;
        }

        v2 = (v2 * 10) % 11;

        if (v2 == 10) {
          v2 = 0;
        }

        if (v2 != cpf[10]) {
          return false;
        } else {
          return true;
        }
      } else if (val.length == 18) {
        let cnpj = val.trim();

        cnpj = cnpj.replace(/\./g, "");
        cnpj = cnpj.replace("-", "");
        cnpj = cnpj.replace("/", "");
        cnpj = cnpj.split("");

        let v1 = 0;
        let v2 = 0;
        let aux = false;

        for (let i = 1; cnpj.length > i; i++) {
          if (cnpj[i - 1] != cnpj[i]) {
            aux = true;
          }
        }

        if (aux == false) {
          return false;
        }

        for (let i = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i; i++, p1--, p2--) {
          if (p1 >= 2) {
            v1 += cnpj[i] * p1;
          } else {
            v1 += cnpj[i] * p2;
          }
        }

        v1 = v1 % 11;

        if (v1 < 2) {
          v1 = 0;
        } else {
          v1 = 11 - v1;
        }

        if (v1 != cnpj[12]) {
          return false;
        }

        for (let i = 0, p1 = 6, p2 = 14; cnpj.length - 1 > i; i++, p1--, p2--) {
          if (p1 >= 2) {
            v2 += cnpj[i] * p1;
          } else {
            v2 += cnpj[i] * p2;
          }
        }

        v2 = v2 % 11;

        if (v2 < 2) {
          v2 = 0;
        } else {
          v2 = 11 - v2;
        }

        if (v2 != cnpj[13]) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    mountObjFornecedor() {
      var fornecedor = new Object();
      fornecedor.id = this.fornecedor.id;
      fornecedor.nome = this.nome;
      fornecedor.nomeFantasia = this.nomeFantasia;
      fornecedor.cpf_cnpj = this.cpf_cnpj;
      fornecedor.inscricaoEstadual = this.inscricaoEstadual;
      fornecedor.contato = this.contato;
      fornecedor.celular = this.celular;
      fornecedor.telefone = this.telefone;
      fornecedor.ramal = this.ramal;
      fornecedor.emails = this.emailsEdit.map((email) => {
        const existente = (this.fornecedor.emails || []).find(
          (item) =>
            item.email?.trim().toLocaleLowerCase() === email.toLocaleLowerCase()
        );
        return existente
          ? { ...existente, email, ativo: true }
          : {
              id: null,
              idFornecedor: this.fornecedor.id,
              email,
              ativo: true,
            };
      });
      fornecedor.cep = this.$refs.endereco.cep;
      fornecedor.logradouro = this.$refs.endereco.logradouro;
      fornecedor.numero = this.$refs.endereco.numero;
      fornecedor.complemento = this.$refs.endereco.complemento;
      fornecedor.bairro = this.$refs.endereco.bairro;
      fornecedor.cidade = this.$refs.endereco.cidade;
      fornecedor.uf = this.$refs.uf;
      fornecedor.ativo = this.fornecedor.ativo;
      return fornecedor;
    },
  },
  created: function () {
    this.nome = this.fornecedor.nome;
    this.nomeFantasia = this.fornecedor.nomeFantasia;
    this.cpf_cnpj = this.fornecedor.cpf_Cnpj;
    this.inscricaoEstadual = this.fornecedor.inscricaoEstadual;
    this.contato = this.fornecedor.contato;
    this.celular = this.fornecedor.celular;
    this.telefone = this.fornecedor.telefone;
    this.ramal = this.fornecedor.ramal;
    //this.email = this.fornecedor.email;
    const emails = (this.fornecedor?.emails || [])
      .filter((e) => e.ativo !== false) // opcional: ignora inativos
      .map((e) => e.email)
      .filter(Boolean)
      .map((e) => e.trim())
      .filter((email, i, arr) => arr.indexOf(email) === i);

    this.emailsEdit = emails;
  },
  mounted() {
    this.readOnly = !getUserPermission(3);
    var endereco = new Object();
    endereco.cep = this.fornecedor.cep;
    endereco.logradouro = this.fornecedor.endereco;
    endereco.numero = this.fornecedor.numero;
    endereco.complemento = this.fornecedor.complemento;
    endereco.bairro = this.fornecedor.bairro;
    endereco.cidade = this.fornecedor.cidade;
    endereco.uf = this.fornecedor.uf;
    this.$refs.endereco.updateObject2(endereco);
  },
  props: {
    onCancelar: { type: Function, default: null },
  },
  components: {
    Endereco,
    EmailsField,
  },
};
</script>
